<div class="modal-header">
  <h3 class="modal-title mb-0" id="sso-add-title">Add SSO connection</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <div class="add-sso__fields">
    <div class="add-sso__field add-sso__field--wide">
      <label class="form-label" for="sso-add-name">Name</label>
      <input
        id="sso-add-name"
        class="form-control"
        maxlength="128"
        autocomplete="off"
        [(ngModel)]="name"
      />
    </div>
    <div class="add-sso__field">
      <label class="form-label" for="sso-add-protocol">Protocol</label>
      <select id="sso-add-protocol" class="form-select" [(ngModel)]="protocol">
        <option value="oidc">OIDC</option>
        <option value="saml">SAML</option>
      </select>
    </div>
    <div class="add-sso__field">
      <label class="form-label" for="sso-add-scope">For</label>
      <select id="sso-add-scope" class="form-select" [(ngModel)]="scope">
        <option value="client">A client's team</option>
        <option value="staff">VIVE staff</option>
      </select>
    </div>
    @if (scope === 'client') {
      <div class="add-sso__field add-sso__field--wide">
        <label class="form-label" for="sso-add-client">Client</label>
        <input
          id="sso-add-client"
          class="form-control"
          placeholder="Search clients"
          autocomplete="off"
          [ngModel]="clientQuery"
          (ngModelChange)="searchClients($event)"
        />
        @if (clientResults.length > 0) {
          <div class="list-group mt-1">
            @for (company of clientResults; track company.id) {
              <button
                type="button"
                class="list-group-item list-group-item-action"
                (click)="chooseClient(company)"
              >
                {{ clientName(company) }}
              </button>
            }
          </div>
        } @else if (searchedClients) {
          <div class="form-text">No clients match.</div>
        }
      </div>
    }
  </div>

  <p class="form-text mb-0 mt-3">
    It starts as a draft. Fill in the identity provider details, domains and
    role mappings, then activate it.
  </p>

  @if (error) {
    <div class="alert alert-danger mb-0 mt-3" role="alert">{{ error }}</div>
  }
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="cancel()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!canCreate"
      (click)="create()"
    >
      Create draft
    </button>
  </div>
</div>
